import { isComplete, type ProgressData } from "../store/progress";

export function lessonStatus(
  lessonId: string,
  quizId: string,
  data: ProgressData,
  passScorePercent = 70,
): "未开始" | "进行中" | "已完成" {
  if (isComplete(lessonId, quizId, data, passScorePercent)) return "已完成";
  return data.read.includes(lessonId) ||
    Object.keys(data.drafts[lessonId] ?? {}).length > 0
    ? "进行中"
    : "未开始";
}
